import React from "react";
import { Users } from "lucide-react";
import ModalShell from "../ModalShell";
import { SkeletonBox } from "../../../../components/SkeletonLoader";
import { deptName, personName, employeeCode } from "../../utils/names";

const MembersModal = ({ styles, t, language, state, onClose }) => {
  const { dept, members, loading } = state;

  return (
    <ModalShell
      styles={styles}
      t={t}
      onClose={onClose}
      title={`${t.membersTitle} — ${deptName(dept, language)}`}
      subtitle={loading ? null : t.membersCount(members.length)}
      footer={<button type="button" style={styles.btnSecondary()} onClick={onClose}>{t.close}</button>}
    >
      {loading ? (
        [1, 2, 3, 4].map((i) => (
          <div key={i} style={styles.memberRow}>
            <div style={{ flex: 1 }}>
              <SkeletonBox width="60%" height="14px" style={{ marginBottom: "6px" }} />
              <SkeletonBox width="35%" height="12px" />
            </div>
            <SkeletonBox width="64px" height="14px" />
          </div>
        ))
      ) : !members.length ? (
        <div style={styles.emptyState}>
          <Users size={40} style={styles.emptyIcon} />
          <p style={styles.emptyTitle}>{t.noMembers}</p>
        </div>
      ) : (
        <>
          <div style={{ ...styles.memberRow, paddingTop: 0 }}>
            <span style={{ ...styles.th, background: "none", border: "none", padding: 0 }}>{t.employee}</span>
            <span style={{ ...styles.th, background: "none", border: "none", padding: 0 }}>{t.employeeCode}</span>
          </div>
          {members.map((m) => {
            const name = personName(m, language) || "—";
            return (
              <div key={m.id} style={styles.memberRow}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ ...styles.deptName, fontWeight: 500 }}>
                    {name}
                  </div>
                  {m.position && <div style={styles.deptAltName}>{m.position}</div>}
                </div>
                <span style={styles.memberCode}>{employeeCode(m)}</span>
              </div>
            );
          })}
        </>
      )}
    </ModalShell>
  );
};

export default MembersModal;
